import type { ReactNode } from 'react';

import { PortalFadeIn } from '@/modules/portal/components/ui/portal-motion';
import { cn } from '@/shared/lib/cn';

export interface PortalDetailItem {
  id: string;
  label: string;
  value: ReactNode;
}

interface PortalDetailGridProps {
  title: string;
  description?: string;
  items: PortalDetailItem[];
  footer?: ReactNode;
  className?: string;
}

export function PortalDetailGrid({
  title,
  description,
  items,
  footer,
  className,
}: PortalDetailGridProps) {
  return (
    <PortalFadeIn delay={0.1}>
      <section className={cn('portal-glass-panel rounded-2xl p-5 sm:p-6', className)}>
        <div className="mb-5">
          <h2 className="text-base font-semibold text-foreground">{title}</h2>
          {description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
        </div>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {items.map((item) => (
            <div
              key={item.id}
              className="rounded-xl border border-border/60 bg-background/60 px-4 py-3 transition-colors hover:border-border hover:bg-background/80"
            >
              <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
                {item.label}
              </p>
              <div className="mt-1.5 text-sm font-medium text-foreground">{item.value}</div>
            </div>
          ))}
        </div>
        {footer ? (
          <div className="mt-5 flex justify-end border-t border-border/50 pt-4">{footer}</div>
        ) : null}
      </section>
    </PortalFadeIn>
  );
}
